<template>
    <el-upload :action="$utils.getUrl('/file/upload')"
               :file-list="fileList" :multiple="false" :accept="accept" list-type="picture"
               :headers="headers"
               :on-success="onSuccess" :on-remove="onRemove" :before-upload="beforeUpload" :on-change="onChange"
               style="max-width: 400px">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip">
            {{tip}}
        </div>
    </el-upload>
</template>
<i18n locale="zh" lang="yaml">
    btn: "选择文件"
</i18n>
<i18n locale="en" lang="yaml">
    btn: "Choose File"
</i18n>

<script>
    import qs from 'qs';

    export default {
        name: "Upload",
        props: ["tip", "accept", "original"],
        data() {
            return {
                headers: {
                    Authorization: this.$utils.getAuthToken(),
                },
                fileList: []
            }
        },
        beforeMount() {
            this.setFileList();
        },
        watch: {
            original() {
                this.setFileList();
            }
        },
        methods: {
            setFileList() {
                if (this.original) {
                    let change = true;
                    if (this.fileList.length > 0) {
                        let file = this.fileList[0];
                        if (file['response'] && file['response']['url'] === this.original) {
                            change = false;
                        }
                    }
                    if (change) {
                        this.fileList = [{name: this.original.substring(this.original.lastIndexOf("/") + 1), url: this.original}]
                    }
                } else {
                    this.fileList = [];
                }
            },
            onSuccess(response, file, fileList) {
                this.fileList = fileList;
                this.$emit("success", response);
            },
            onRemove(file) {
                let url;
                if (file.response) {
                    url = file.response.url;
                } else {
                    url = file.url;
                }

                if (url) {
                    this.$axios.post("/file/delete", qs.stringify({
                        path: url
                    })).then(() => {
                        this.$emit("success", {});
                    });
                }
            },
            beforeUpload(file) {
                let suffix = file.name.substring(file.name.lastIndexOf('.'));
                let isRight = false;

                if (this.accept) {
                    let arr = this.accept.split(",");
                    arr.forEach(v => {
                        if (v === suffix) {
                            isRight = true;
                            return false;
                        }
                    })
                } else {
                    isRight = true;
                }

                if (!isRight && this.tip) {
                    this.$message.error(this.tip);
                }

                return isRight;
            },
            onChange(files, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
            }
        }
    }
</script>